import { Button, Dropdown } from "react-bootstrap";
import DropdownDownIcon from "components/icons/DropdownDownIcon";
import { CircleCheckBox } from "components/form/CircleCheckBox";
import DropdownUpIcon from "components/icons/DropdownUpIcon";

function ClearButton({ handleClear, allSelected }){
    if(allSelected) return null;

    return(
        <Button
            variant="link"
            className="workspace-filter--clear-btn btn-sm"
            onClick={handleClear}
        >
            Clear
        </Button>
    )
}

function DropdownItem({ 
    item, 
    openId, 
    setOpenId, 
    isSelected,
    handleWorkspaceToggle,
    handleToggleOrg ,
    unselected_workspace_ids
}) {
    const isOpen = openId === item.id;
    const organizationTitle = item?.personal && item?.owner ? "My Workspace" : item?.name;
    const workspace_ids = item?.workspaces?.map(w => w.id) || [];
    const hasUnlselectedWorkspaces = workspace_ids.some(id => unselected_workspace_ids.includes(id));

    const openMenuOrg = () => {
        if (isOpen) {
            setOpenId(null);
        } else {
            setOpenId(item.id);
        }
    }

    const onWorkspaceToggle = (e, workspace) => {
        e.preventDefault();
        e.stopPropagation();

        handleWorkspaceToggle(workspace);
    }

    const onOrgToggle = (e, organization) => {
        e.preventDefault();
        e.stopPropagation();

        handleToggleOrg(organization);
    }

    return (
        <div className={`submenu-container ${isOpen ? 'open' : ''}`}>
            <div
                className="dropdown-item d-flex align-items-center cursor-pointer"
                onClick={openMenuOrg}
            >
                <div
                    onClick={(e) => onOrgToggle(e, item)}
                >
                    {
                        hasUnlselectedWorkspaces ? 
                            <CircleCheckBox 
                                height={18} 
                                width={18} 
                                isChecked={false} 
                                isCustomNotCheckedIcon={true}
                            />
                        :
                            <CircleCheckBox 
                                height={18} 
                                width={18} 
                                isChecked={isSelected(item, 'organization')} 
                            />
                        
                    }
                </div>

                <span 
                    className="text-truncate submenu-organization-name"
                >
                    {organizationTitle}
                </span>

                {
                    isOpen ? 
                    <DropdownUpIcon height={'8'} width={'8'} className="dropdown-icon"/> :
                    <DropdownDownIcon height={'8'} width={'8'} className="dropdown-icon" color={'#0F172A'}/>
                }
            </div>

            {isOpen && (
                <div className="submenu-items">
                    {
                        item?.workspaces.length > 0 ?
                            item.workspaces.map((workspace, index) => (
                                <Dropdown.Item 
                                    className="d-flex align-items-center" 
                                    key={workspace.id}
                                    onClick={(e) => onWorkspaceToggle(e, workspace)}
                                >    
                                    <CircleCheckBox height={18} width={18} isChecked={isSelected(workspace, 'workspace')}/>
                                    <span className="text-truncate submenu-workspace-name">{workspace.name}</span>
                                </Dropdown.Item>
                            )) : 
                        (
                            <Dropdown.Item className="text-center">    
                                <span className="text-truncate submenu-workspace-name">No Workspaces</span>
                            </Dropdown.Item>
                        )
                    }
                </div>
            )}
        </div>
    )
}

function WorkspaceFilter({
    organizations = [],
    unselected_workspace_ids,
    selectedWorkspaces,
    allSelected,
    openId,
    setOpenId,
    isSelected,
    handleWorkspaceToggle,
    handleToggleOrg,
    handleClear,
}){

    return(
        <div className="workspace-filter d-flex align-items-center">
            <ClearButton 
                handleClear={handleClear}
                allSelected={allSelected}
            />
    
            <Dropdown className="workspace-filter--dropdown">
                <Dropdown.Toggle
                    variant={allSelected ? 'outline-gray' : 'orange'}
                    size="sm"
                    className={allSelected ? '' : 'fw-500'}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        {
                            allSelected ? (
                                <span>Select Workspace</span>
                            ) : (
                                <>
                                    <span>Selected Workspaces</span>
                                    <div className="workspace-count d-flex align-items-center justify-content-center">{selectedWorkspaces.length}</div> 
                                </>
                            )
                        }
                    </div>

                    <DropdownDownIcon
                        height="8"
                        width="8"
                        className="dropdown-icon"
                        {...(allSelected ? {} : { color: 'white' })}
                    />
                </Dropdown.Toggle>
        
                <Dropdown.Menu>
                    {
                        organizations?.map((item) => (
                            <DropdownItem 
                                key={item.id}
                                item={item}
                                openId={openId}
                                setOpenId={setOpenId}
                                isSelected={isSelected}
                                handleWorkspaceToggle={handleWorkspaceToggle}
                                handleToggleOrg={handleToggleOrg}
                                unselected_workspace_ids={unselected_workspace_ids}
                            />
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default WorkspaceFilter;